<template>
  <div class="row offer-filter pad-top">
    <div class="col-md-12">
      <MultiSelect
                   ref="multiselect"
                   :options="options"
                   :show-labels="false"
                   track-by="title"
                   label="title"
                   placeholder="Выбрать смену"
                   v-model="value"
                   @select="handleChangeClose"
      >
      </MultiSelect>
    </div>
  </div>
</template>

<script>
import MultiSelect from 'vue-multiselect'

export default {
  components: {
    MultiSelect
  },
  mounted () {
  },
  data () {
    return {
      value: { title: 'Обе смены', value: null },
      options: [
        { title: 'Обе смены', value: null },
        { title: 'Рабочая смена', value: true },
        { title: 'Нерабочая смена', value: false }
      ]
    }
  },
  methods: {
    handleChangeClose (event) {
      this.$root.$emit('handleChangeClose', event.value)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// WorkShifts.vue?6c9ad697